export default {
  creativeModal: {
    padding: '24px 24px 24px',
    minWidth: ['unset', 'unset', '520px'],
    textarea: {
      minHeight: 138
    }
  },
  acceptButton: {
    pt: '8px'
  }
};